<template>
  <div>
    <app-header><org-nav></org-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Painel de Controlo</h2>
      </div>
      <p>Painel de gestão e controlo da prova...</p>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import OrgNav from './Nav.vue'

export default {
  name: 'CpPainel',
  components: {
    AppHeader,
    OrgNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Painel.vue?a61694f2